import { useNavigate } from "react-router-dom";
import { Facebook, Instagram, Music2, Send } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import LogoChip from "@/components/LogoChip";

export default function Footer() {
  const { t, scrollToSection, openFaq, toast } = useStore();
  const navigate = useNavigate();

  const go = (id) => () => scrollToSection(id);
  const blog = () => toast(t("toast.blog"));

  const cols = [
    {
      title: t("footer.shop"),
      links: [
        { label: t("footer.allProducts"), action: go("products"), testid: "footer-all-products" },
        { label: t("footer.knee"), action: go("products"), testid: "footer-knee" },
        { label: t("footer.bag"), action: go("products"), testid: "footer-bag" },
        { label: t("product.set"), action: go("products"), testid: "footer-set" },
      ],
    },
    {
      title: t("footer.about"),
      links: [
        { label: t("footer.ourStory"), action: go("story"), testid: "footer-story" },
        { label: t("footer.active"), action: go("active"), testid: "footer-active" },
        { label: t("footer.blog"), action: blog, testid: "footer-blog" },
      ],
    },
    {
      title: t("footer.help"),
      links: [
        { label: "FAQ", action: openFaq, testid: "footer-faq" },
        { label: t("footer.track"), action: () => navigate("/track"), testid: "footer-track" },
        { label: t("footer.delivery"), action: go("support"), testid: "footer-delivery" },
        { label: t("footer.contact"), action: () => window.open("https://t.me/pamakcamofficial", "_blank", "noopener"), testid: "footer-contact" },
      ],
    },
  ];

  const socials = [
    { label: "Facebook", href: "https://www.facebook.com/share/1BHuirEaHu/?mibextid=wwXIfr", icon: Facebook, testid: "social-facebook" },
    { label: "Instagram", href: "https://www.instagram.com/pamakofficial?stkn=bGlvd2Rtb3FuNGZs&utm_source=qr", icon: Instagram, testid: "social-instagram" },
    { label: "TikTok", href: "https://www.tiktok.com/@pamakofficial", icon: Music2, testid: "social-tiktok" },
    { label: "Telegram", href: "https://t.me/pamakcamofficial", icon: Send, testid: "social-telegram" },
  ];

  return (
    <footer data-testid="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <LogoChip small />
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <p className="footer-title">{col.title}</p>
              <ul className="footer-links">
                {col.links.map((l) => (
                  <li key={l.testid}>
                    <button className="footer-link" data-testid={l.testid} onClick={l.action}>
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <p className="footer-title">{t("footer.follow")}</p>
            <ul className="footer-links footer-socials">
              {socials.map((s) => (
                <li key={s.testid}>
                  <a className="footer-link" href={s.href} target="_blank" rel="noopener noreferrer" data-testid={s.testid}>
                    <s.icon size={13} /> {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{t("footer.copyright")}</span>
          <span className="footer-tag">
            <img src="/flower-black.png" alt="" />
            {t("footer.tagline")}
          </span>
        </div>
      </div>
    </footer>
  );
}
